class StickySection extends HTMLElement {
  constructor() {
    super();

    this.section = this.closest('.section');
    if (this.section) this.section.classList?.add('section--sticky');

    if (this.section) this.resizeObserver.observe(document.body);

    console.log(this.section);
  }

  resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      this.setPosition();
    }
  });

  setPosition() {
    console.log(window.innerHeight, this.section.clientHeight);
    const top = window.innerHeight - this.section.clientHeight > 0 ? 0 : window.innerHeight - this.section.clientHeight;
    this.section.style.setProperty('--top-position', `${top}px`);
  }
}

customElements.get('sticky-section') || customElements.define('sticky-section', StickySection);
